import { render, staticRenderFns } from "./ItemManage.vue?vue&type=template&id=d35f163e"
import script from "./ItemManage.vue?vue&type=script&lang=ts"
export * from "./ItemManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports